// @flow
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { ColProps } from 'react-bootstrap/Col'

interface Props {
  children: React.ReactNode
  className?: string
}

export default function UnauthLayout(props: Props & ColProps) {
  return (
    <>
      <div className={`${props.className} unauth`}>
        <Container fluid="xl" className={'content'}>
          <Row className={'align-items-center dialog-row'}>
            <Col
              xs={props.xs || 12}
              sm={props.sm || 12}
              md={props.md || 7}
              lg={props.lg || 6}
              xl={props.xl || 6}
              xxl={props.xxl || 6}
              className={'dialog-col'}
            >
              {props.children}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}
